export const TOKEN = "TF_SYSTEM_TOKEN";
export const REFRESH_TOKEN = "TF_SYSTEM_REFRESH_TOKEN";
export const EXPIRES_AT = "TF_SYSTEM_TOKEN_EXPIRES_AT";
